<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable>
              <el-option v-for="item in projects" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分类：">
            <el-select size="medium" filterable v-model="searchForm.CATALOG_ID" placeholder="请选择" clearable>
              <el-option v-for="item in kinds" :key="item.CATALOG_ID" :label="item.CATALOG_NAME"
                :value="item.CATALOG_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="searchList">筛选</el-button>
            <el-button size="medium" class="btn" type="primary" plain @click="exportSearchList">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="产品编号" prop="PRODUCT_CODE" min-width="100px"></el-table-column>
          <el-table-column label="产品名称" prop="NAME" min-width="100px"></el-table-column>
          <el-table-column label="产品单位" prop="TYPE_UNIT" min-width="100px"></el-table-column>
          <el-table-column label="销售数量" prop="REAL_COUNT"></el-table-column>
          <el-table-column label="销售金额" prop="TOTAL_FEE"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      kinds: [],
      tableData: [],
      dialogVisible: false,
      inwareDate: [],
      name: '',
      pro_type: '',
      total_count: 0,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: {},
      pName: '',
      returnDialogVisible: false,
      region: '',
      deliverId: '',
      arr: [],
      searchForm: {},
      projects: [],
      flag: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.$set(this.searchForm, 'CATALOG_ID', this.$store.state.PRODUCTRANKLIST_ALL.CATALOG_ID);
    this.$set(this.searchForm, 'PROJECT_ID', this.$store.state.PRODUCTRANKLIST_ALL.PROJECT_ID);
    this.$set(this.searchForm, 'PRODUCT_NAME', this.$store.state.PRODUCTRANKLIST_ALL.PRODUCT_NAME);
    this.$set(this.searchForm, 'DAY_INTERVAL', this.$store.state.PRODUCTRANKLIST_ALL.DAY_INTERVAL);
    this.queryPro();
    this.getKind();
  },
  methods: {
    // 拉去分类
    getKind() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 37,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.kinds = result[0].list;
        this.flag = result[0].FLAG;
        this.queryList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----拉取项目点
    queryPro() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.projects = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    searchList() {
      this.currentPage = 1;
      this.queryList();
    },
    // ------------------------拉取数据
    queryList() {
      this.$store.dispatch(
        'PRODUCTRANKLIST_ALL',
        {
          PROJECT_ID: this.searchForm.PROJECT_ID,
          PRODUCT_NAME: this.searchForm.PRODUCT_NAME,
          DAY_INTERVAL: this.searchForm.DAY_INTERVAL,
          CATALOG_ID: this.searchForm.CATALOG_ID,
        },
      );
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 36,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
        params.FLAG = this.flag;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params)
        .then((result) => {
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportSearchList() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 38,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
        params.FLAG = this.flag;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params)
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryList();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/productRankList.vue